// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"fb413acc","425":"68cf59db","510":"dbb18b11","532":"414d80e7","633":"793dd206","634":"fec6a704","922":"49bef6ab","937":"cb01e7db","972":"fce1498c"}[chunkId] + ".chunk.js";
};